import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  notification: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top:  '-6px',
    right: '-9px',
    width: '17px',
    height: '17px',
    borderRadius: '50%',
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 2px 1px 0px rgb(0 0 0 / 14%), 0px 1px 2px 0px rgb(0 0 0 / 12%)',
  },
}))
